import NotInformation from '../../../../../../components/NotInformation';
import React from 'react';
import CustomCard from '../../../../../../components/CustomCard';
import { DocumentationIcon, TrashIcon, TrashOutlineIcon } from '../../../../../../components/buttons/IconButtons';
import ZoneItem from './ZoneItem';
import ButtonAction from '../../../../../../components/buttons/ButtonAction';
import { CustomCheckbox } from '../../../../../../components/CustomCheckbox';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const CustomizedItem = ({
    t,
    list,
    onDelete=null,
    title = "custom_access",
    showNoInformation = true,
    showCard = false,
    iconDelete = true,
    TitleIcon = DocumentationIcon,
    setSelectedList,
    setDeleteCustomizedModal,
    selectedList,
    isAllChecked,
    handleCheckboxChange,
    handleDeleteAll,
    showCheckbox = true,        
    showSelectAll = true,      
    showDeleteButton = true,
}) => {
    const ListAll = ({ list, onDelete }) => {
        return (
            <>
                {list?.map((item, index) => (
                    <div className={`px-0 ${index < list.length - 1 ? 'mb-2' : ''}`} id={`id_${item?.zoneId || index}`} key={`key_${item?.zoneId ?? 'noId'}_${index}`}>
                        <CustomCard classes='w-100' classCard='card-shades-300-100' classContent='p-10px'>
                            <div className='row align-items-center w-100'>
                                <div className='col-auto d-flex align-items-center px-0'>
                                    {showCheckbox && (
                                        <CustomCheckbox
                                            id={item?.id}
                                            checked={selectedList?.includes(item?.id)}
                                            onChange={handleCheckboxChange}
                                            size='small'
                                        />
                                    )}
                                </div>
                                <div className='col-12 col-md px-0'>
                                    <ZoneItem item={item} />
                                </div>

                                {iconDelete && (
                                    <div
                                    className="col-auto d-flex align-items-center justify-content-end flex-shrink-0 px-0 cursor-pointer"
                                        onClick={() => onDelete && onDelete(index)}
                                    >
                                    <TrashIcon className="icon-color-shades-400 icon-hover-shades-950" width={16} height={16} />
                                    </div>
                                )}
                            </div>
                        </CustomCard>
                    </div>
                ))}
            </>
        );
    };

    return (
        <>
            <CustomCard classes={'w-100 mt-3'} classCard={'card-border-8px '}>
                <div className='d-flex align-items-center m-3'>
                    {TitleIcon && <TitleIcon className='w-h-24px' />}
                    {title !== '' && <p className='fs-16px ibl-font-w-600 font-color-general-950 py-3'>{t(title)}</p>}
                    {showDeleteButton && (  <ButtonAction
                        id='btn_ci_delete'
                        name='delete'
                        className='btn-icon-delete ms-auto'
                        Icon={TrashOutlineIcon}
                        disabled={selectedList?.length === 0}
                        onClick={() => setDeleteCustomizedModal(true)}
                    />)}
                </div>
                {list?.length > 0 ? (
                    <>
                        {showSelectAll && (
                        <div className={'mb-3'}>
                            <CustomCheckbox
                                id={'cb_ci_de_select_all'}
                                trans={t('de_/_select_all')}
                                checked={isAllChecked}
                                onChange={handleDeleteAll}
                                marginbutton={true}
                            />
                        </div> )}
                        <div className={'overflow-y-auto maxh-320px'}>
                            {showCard ? (
                                <div className={'w-100 card-border-8px p-12px border-full-shades-300'}>
                                    <ListAll
                                        list={list}
                                        onDelete={onDelete}
                                        selectedList={selectedList}
                                        handleCheckboxChange={handleCheckboxChange}
                                        showCheckbox={showCheckbox}
                                    />
                                </div>
                            ) : (
                                <ListAll
                                    list={list}
                                    onDelete={onDelete}
                                    selectedList={selectedList}
                                    handleCheckboxChange={handleCheckboxChange}
                                    showCheckbox={showCheckbox}
                                />
                            )}
                        </div>
                    </>
                ) : (
                    <>{showNoInformation && <NotInformation text={t('no_custom_shifts_added_yet')} card={true} />}</>
                )}
            </CustomCard>
        </>
    );
};

export default CustomizedItem;
